import { domTool, videoTool } from '../util';
import { ResizeObserver } from '../util/resize-observer';
/** 引用方式枚举 */
var VideoFillType;
(function (VideoFillType) {
    VideoFillType["COVER"] = "cover";
    VideoFillType["CONTAIN"] = "contain";
})(VideoFillType || (VideoFillType = {}));
/**
 * Video元素reszie类，添加到Observer后会自动根据容器尺寸调整
 */
var VideoResizeAutoFill = /** @class */ (function () {
    function VideoResizeAutoFill(videoElement, minFillBlackBorder) {
        if (minFillBlackBorder === void 0) { minFillBlackBorder = 10; }
        /** 默认最小自动黑边范围，默认10像素 */
        this.minFillBlackBorder = 10;
        this.videoElement = videoElement;
        this.minFillBlackBorder = minFillBlackBorder;
        this.addToObserver();
    }
    /**
    * video标签默认样式object-fit: contain，这样高宽比不匹配时候，会被添加黑边。
    * 该方法用于当视频显示尺寸和播放器尺寸有很小的误差时候（例如出现了10px以下的黑边），那就直接铺满video画面(object-fit: cover)避免黑边
    * 的产生，这种情况下人眼看不出比例的实际变化
    * 在视频原始尺寸发生变化和video元素尺寸发生变化两种情况下，需要调用此函数检查。
    */
    VideoResizeAutoFill.prototype.resizeAutoFill = function () {
        if (!(this.videoElement instanceof HTMLVideoElement)) {
            // TODO：265暂时没有方案处理小黑边
            return;
        }
        if (this.minFillBlackBorder <= 0) {
            // 如果没有设置最小适配黑边，就无需计算，默认即可
            return;
        }
        if (this.videoElement.videoWidth === 0 || this.videoElement.videoHeight === 0) {
            // 在多video模式下，video元素宽高是0，继续往下计算是没有意义的
            return;
        }
        var videoElementSize = domTool.getDomSize(this.videoElement);
        var videoElementWidth = videoElementSize.width, videoElementHeight = videoElementSize.height;
        // 这是假设为contain模式，算出来的画面宽度
        var picWidth = this.videoElement.videoWidth * (videoElementHeight / this.videoElement.videoHeight);
        // 这是假设为contain模式，算出来的画面高度
        var picHeight = this.videoElement.videoHeight * (videoElementWidth / this.videoElement.videoWidth);
        if (picWidth < videoElementWidth && picWidth >= videoElementWidth - this.minFillBlackBorder) {
            // 画面宽度小于容器宽度左右出现了黑边，并且小于阀值
            videoTool.setElementFitType(this.videoElement, VideoFillType.COVER);
        }
        else if (picHeight < videoElementHeight && picHeight >= videoElementHeight - this.minFillBlackBorder) {
            // 画面高度小于容器高度上下出现了黑边，并且小于阀值
            videoTool.setElementFitType(this.videoElement, VideoFillType.COVER);
        }
        else {
            // 容忍黑边
            videoTool.setElementFitType(this.videoElement, VideoFillType.CONTAIN);
        }
    };
    /**
     * 销毁，并停止监听video元素
     */
    VideoResizeAutoFill.prototype.destroy = function () {
        if (!this.videoElement || !(this.videoElement instanceof HTMLVideoElement)) {
            // 在非video播放模式下，不能通过这个Observer调整尺寸
            return;
        }
        if (!this.videoResizeObserver) {
            return;
        }
        this.videoResizeObserver.disconnect();
        this.videoResizeObserver.unobserve(this.videoElement);
        this.videoResizeObserver = null;
        this.videoElement = null;
    };
    /**
     * 添加到Observer做自动容器适应
     */
    VideoResizeAutoFill.prototype.addToObserver = function () {
        var _this = this;
        if (!this.videoElement) {
            return;
        }
        if (!(this.videoElement instanceof HTMLVideoElement)) {
            // 在非video播放模式下，不能通过这个Observer调整尺寸
            return;
        }
        this.videoResizeObserver = new ResizeObserver(function () {
            _this.resizeAutoFill();
        });
        this.videoResizeObserver.observe(this.videoElement);
    };
    return VideoResizeAutoFill;
}());
export default VideoResizeAutoFill;
